/**
 * Purpose:
 * Defines opt-out flags for interceptor behaviors that should remain global by default
 * but can be bypassed for specific business flows such as inline action dialogs.
 */
import { HttpContextToken } from '@angular/common/http';

export const SKIP_GLOBAL_FORBIDDEN_REDIRECT = new HttpContextToken<boolean>(() => false);
